import { render } from "./specialA.vue?vue&type=template&id=219fc314&scoped=true"
import script from "./specialA.vue?vue&type=script&lang=js"
export * from "./specialA.vue?vue&type=script&lang=js"

import "./specialA.vue?vue&type=style&index=0&id=219fc314&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-219fc314"]])

export default __exports__